import React, { useState, useEffect } from 'react';

const Sidebar = ({ activePage, setActivePage }) => {
  const [expandedDataMaster, setExpandedDataMaster] = useState(true);

  // Auto-expand Data Master if categories is active
  useEffect(() => {
    if (activePage === 'categories') {
      setExpandedDataMaster(true);
    }
  }, [activePage]);

  const menuItems = [
    { id: 'orders', label: 'Orders', icon: '📦' },
    { id: 'products', label: 'Products', icon: '🛍️' },
    { id: 'merchants', label: 'Merchants', icon: '🏪' },
    { id: 'payments', label: 'Payments', icon: '💳' },
  ];

  const dataMasterChildren = [
    { id: 'categories', label: 'Categories', icon: '📁' },
  ];

  const toggleDataMaster = () => {
    setExpandedDataMaster(!expandedDataMaster);
  };

  const isDataMasterActive = () => {
    return activePage === 'categories';
  };

  return (
    <div className="w-64 bg-white border-r border-gray-200 h-full flex flex-col">
      <div className="p-6 border-b border-gray-200">
        <img
          src="/logo_full.png"
          alt="Admin Panel"
          className="h-10 w-auto object-contain"
        />
      </div>
      <nav className="flex-1 p-4 overflow-y-auto">
        <ul className="space-y-2">
          {/* Dashboard */}
          <li>
            <button
              onClick={() => setActivePage('dashboard')}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                activePage === 'dashboard'
                  ? 'bg-indigo-50 text-indigo-600 font-medium'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <span className="text-xl">📊</span>
              <span>Dashboard</span>
            </button>
          </li>

          {/* Other Menu Items */}
          {menuItems.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => setActivePage(item.id)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                  activePage === item.id
                    ? 'bg-indigo-50 text-indigo-600 font-medium'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <span className="text-xl">{item.icon}</span>
                <span>{item.label}</span>
              </button>
            </li>
          ))}

          {/* Data Master - Expandable */}
          <li>
            <div>
              <button
                onClick={toggleDataMaster}
                className={`w-full flex items-center justify-between px-4 py-3 rounded-lg transition-colors ${
                  isDataMasterActive()
                    ? 'bg-indigo-50 text-indigo-600 font-medium'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className="text-xl">📋</span>
                  <span>Data Master</span>
                </div>
                <svg
                  className={`w-4 h-4 transition-transform ${expandedDataMaster ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {expandedDataMaster && (
                <ul className="mt-1 ml-4 space-y-1">
                  {dataMasterChildren.map((child) => (
                    <li key={child.id}>
                      <button
                        onClick={() => setActivePage(child.id)}
                        className={`w-full flex items-center gap-3 px-4 py-2 rounded-lg transition-colors ${
                          activePage === child.id
                            ? 'bg-indigo-50 text-indigo-600 font-medium'
                            : 'text-gray-700 hover:bg-gray-50'
                        }`}
                      >
                        <span className="text-lg">{child.icon}</span>
                        <span className="text-sm">{child.label}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </li>

          {/* Pinned Reports */}
          <li>
            <button
              onClick={() => setActivePage('pinned-reports')}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                activePage === 'pinned-reports'
                  ? 'bg-indigo-50 text-indigo-600 font-medium'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <span className="text-xl">📌</span>
              <span>Pinned Reports</span>
            </button>
          </li>

          {/* DB Agent Chat */}
          <li>
            <button
              onClick={() => setActivePage('chat')}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                activePage === 'chat'
                  ? 'bg-indigo-50 text-indigo-600 font-medium'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <span className="text-xl">💬</span>
              <span>DB Agent Chat</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
